import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/organizations/memberRemove';
import { fetchRequest as fetchMembers } from '../../actions/organizations/members';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

function* operation(action) {
  const { orgId, userId } = action.payload;
  try {
    yield call(
      axios.delete,
      `${config.API_URL}/organization/${orgId}/members/${userId}`,
      { headers: getLocalUser() },
    );
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'Member removed' });
    yield put(fetchSuccess({ userId }));
    yield put(fetchMembers({ orgId }));
  } catch (err) {
    yield put(ErrorAction(err));
    const message = err?.response?.data?.message || 'Could not remove member';
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message });
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  // takeEvery: removals of different members may be dispatched in parallel.
  yield takeEvery(REQUEST, operation);
}
